import instance from '@/plugins/axios'
import type { ReservationDTO } from '@/modules/reservations/models/reservation'
import type { ReservationUpdateDTO } from '@/modules/reservations/models/reservation-update'
import type { ResponseResult, PageResponse } from '@/core/models/api-responses'
import { ReservationCancelReason } from '../models/reservationCancelReason.enum';

async function getAll(queryString = ''): Promise<ResponseResult<PageResponse<ReservationDTO>>> {
  const url = queryString ? `/Reservations?${queryString}` : '/Reservations'
  const res = await instance.get<ResponseResult<PageResponse<ReservationDTO>>>(url)
  return res.data
}

async function downloadExcel(queryString = '') {
  const url = queryString ? `/Reservations/download?${queryString}` : '/Reservations/download'
  await instance.post(url, null, {
    responseType: 'blob'
  })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const currentDate = new Date().toLocaleDateString();
      const filename = `PlataformaGestãoDeReservasMafra_Extração_${currentDate}.xlsx`
      link.setAttribute('download', filename); // Filename
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch(error => {
      console.error('Error downloading Excel file:', error);
      throw error;
    });
}

async function getById(id: string): Promise<ResponseResult<ReservationDTO>> {
  const res = await instance.get<ResponseResult<ReservationDTO>>(`/Reservations/${id}`)
  return res.data
}

async function cancel(id: string, cancelationReason: ReservationCancelReason): Promise<ResponseResult<any>> {
  const res = await instance.put<ResponseResult<any>>(
    `/Reservations/cancel/${id}?cancelationReason=${cancelationReason}`
  )
  return res.data
}

async function update(
  id: string,
  payload: ReservationUpdateDTO
): Promise<ResponseResult<any>> {
  const res = await instance.put<ResponseResult<any>>(`/Reservations/${parseInt(id)}`, payload)
  return res.data
}

export default {
  getAll,
  getById,
  downloadExcel,
  cancel,
  update
}
